export default [
    {
        path: 'reabertura-atendimento',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-reabertura-atendimento' */
            '@/views/pronto-atendimento/reabertura-atendimento/Index'
        ),
        redirect: 'reabertura-atendimento/index',
        children: [
            {
                name: 'pronto-atendimento-reabertura-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-reabertura-atendimento' */
                    '@/views/pronto-atendimento/reabertura-atendimento/List.vue'
                ),
            },
        ],
    },
]